import { highlights } from '@/mocks/russianMom';

export default function HighlightSection() {
  return (
    <section id="highlights" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.5fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-bookmark-3-line" aria-hidden="true"></i>
              观看理由
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              为什么值得花时间看完它
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              它不属于那种靠反转取胜的剧集，而是把力气花在人物的日常与情绪上。
              如果你正在寻找一部可以安静看完、看完还能回味一阵子的作品，它值得放进清单。
            </p>
            <div className="mt-6 rounded-lg border border-accent-200 bg-accent-50 p-5">
              <div className="flex items-center gap-2">
                <i className="ri-double-quotes-l text-2xl text-accent-600" aria-hidden="true"></i>
                <p className="font-heading text-sm font-semibold text-accent-900">一句话总结</p>
              </div>
              <p className="mt-2 text-sm leading-7 text-foreground-800">
                没有惊天动地的起伏，只有一句迟迟说不出口的“我想你”。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {highlights.map((h) => (
              <article
                key={h.id}
                className="rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-secondary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${h.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{h.title}</h3>
                <p className="mt-2 text-xs leading-6 text-foreground-600">{h.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}